import { Controller } from "@hotwired/stimulus"

// Legacy's questionnaire: ticking "None of the above" unticks the question's other options and locks them;
// unticking it frees them again. Applied on connect too, so a redrawn question with "none" saved shows the same.
export default class extends Controller {
  static targets = ["none", "option", "hint"]

  connect() {
    this.apply()
  }

  toggle() {
    this.apply()
  }

  apply() {
    const none = this.hasNoneTarget && this.noneTarget.checked
    this.optionTargets.forEach((option) => {
      if (none) option.checked = false
      option.disabled = none
    })
    if (this.hasHintTarget) this.hintTarget.classList.toggle("hidden", !none)
  }
}
